export const AgricultureMapConstants: any = {
    ADMIN_BOUNDARIES_HIE: ['STATE', 'DISTRICT', 'BLOCK', 'PANCHAYAT', 'VILLAGE', 'FARM'],
    CITY_BOUNDARIES_HIE: ['COUNTRY', 'CITY', 'BLOCK'],
    LOCATIONS: {
        'ALL': 'ALL',
        'INDIA': 'INDIA',
        'STATE': 'STATE',
        'DISTRICT': 'DISTRICT',
        'ADA': 'ADA',
        'KRISHIBHAVAN': 'KRISHIBHAVAN',
        'MANDAL': 'MANDAL',
        'MITANK': 'MITANK',
        'PANCHAYAT':'PANCHAYAT',
        'VILLAGE': 'VILLAGE',
        'TAMILNADU': 'TAMILNADU',
        'ODISHA': 'ODISHA',
        'BLOCK': 'BLOCK',
        'CROP': 'CROP',
        'KARUNGADU': 'KARUNGADU',
        'SATELLITE': 'SATELLITE',
        'CROPGROWTH': 'CROPGROWTH',
        'INDIA_NEW': 'INDIA_NEW',
        'CONTENTMANAGEMENT': 'CONTENT_MANAGEMENT',
        'BOUNDARYMANAGEMENT': 'BOUNDARY_MANAGEMENT',
        'PICTORIALANALYSIS':'PICTORIALANALYSIS',
        'USER_DEFINED': 'USER_DEFINED',
        'CROPSOWNINFORMATION':'CROPSOWNINFORMATION'
    },
    LOCATION_TYPES:{
        'COUNTRY':'COUNTRY',
        'STATE': 'STATE',
        'STATE BOUNDARY': 'STATE BOUNDARY',
        'DISTRICT': 'DISTRICT',
        'DISTRICT BOUNDARY': 'DISTRICT BOUNDARY',
        'BLOCK': 'BLOCK',
        'BLOCK BOUNDARY': 'BLOCK BOUNDARY',
        'MANDAL': 'MANDAL',
        'VILLAGE': 'VILLAGE',
        'VILLAGE BOUNDARY': 'VILLAGE BOUNDARY',
        'FARM':'FARM',
        'FARM BOUNDARY':'FARM BOUNDARY'
    },
    LOCTYPE_VS_ZOOMLEVEL : {
        "STATE" : 8,
        "DISTRICT" : 11,
        "ADA" : 13,
        "TALUK" : 13,
        "LSC" : 13,
        "KRISHIBHAVAN" : 14,
        "VILLAGE" : 15,
        "LAC" : 15,
        "WARD" : 16,
        "FARM" : 17
    },
    VIEWS: {
        'ALL': 'ALL',
        'ADMIN': 'ADMIN',
        'BASIN': 'BASIN',
        'COMBINED_BASIN': 'COMBINED_BASIN',
        'AGRI':'AGRI',
        'REVENUE':'REVENUE',
        'POLITICAL' : 'POLITICAL'
    },
    SOURCES: {
        'ALL': 'ALL',
        'GEOSERVER': 'GEOSERVER',
        'BACKEND': 'BACKEND',
    },
    COMPONENT: {
        'CROPANALYTICS': 'CROPANALYTICS',
        'SATELLITEDATAPROCESSING': 'SATELLITE_DATA_PROCESSING',
        'CROPGROWTH': 'CROPGROWTH',
        'BOUNDARYMANAGEMENT': 'BOUNDARY_MANAGEMENT',
        'CONTENTMANAGEMENT': 'CONTENT_MANAGEMENT',
        'PICTORIALANALYSIS':'PICTORIALANALYSIS',
        'CROPGROWTHANALYSIS': 'CROPGROWTHANALYSIS',
        'DROUGHT' :'DROUGHT',
        'PLOTADDITION' : 'PLOTADDITION',
        'ANALYTICS': 'ANALYTICS',
	    'GEOPORTAL': 'GEOPORTAL',
        'CROPSOWNANALYSIS': 'CROPSOWNANALYSIS',
        'HARVESTASSESSMENT':'HARVESTASSESSMENT',
        'CROPSOWNINFO' : 'CROPSOWNINFO',
        'UNIFIEDFARMERDATABASE' : 'UNIFIEDFARMERDATABASE',
        'WEATHERFORECAST' : 'WEATHERFORECAST' ,
        'CROPSOWNINFORMATION' : 'CROPSOWNINFORMATION',
        'RAINFALLFORECAST' : 'RAINFALLFORECAST',
        'SOILINFORMATION':'SOILINFORMATION',
        'RAINFALLACTUAL' : 'RAINFALLACTUAL',
        'TEMPERATUREFORECAST': 'TEMPERATUREFORECAST',
        'GROUNDTRUTH': 'GROUNDTRUTH',
        'USERANALYTICSFARMER' : 'USERANALYTICSFARMER',
        'HUMIDITYFORECAST' : 'HUMIDITYFORECAST',
        'HUMIDITYACTUAL' : 'HUMIDITYACTUAL',
        'SOILTESTING':'SOILTESTING',
        'SOILMOISTURE' : 'SOILMOISTURE',
        'PESTSTRESSGIS': 'PESTSTRESSGIS',
        'MINISTERDASHBOARD':'MINISTERDASHBOARD',
        'CROPSTRESSGIS' : 'CROPSTRESSGIS',
        'SMBASEDIRRIGATIONGIS': 'SMBASEDIRRIGATIONGIS',
        'CROPLOSSASSESSMENT' : 'CROPLOSSASSESSMENT',
        'ADD_FARM_PLOT': 'ADD_FARM_PLOT',
        'HEATWAVE': 'HEATWAVE',
        'HEATINDEX':'HEATINDEX',
        'THUNDERSTORM':'THUNDERSTORM',
        'COLDWAVE':'COLDWAVE',
        'NOWCAST':'NOWCAST',
        'STATIONWARNINGS' : 'STATIONWARNINGS',
        'KOLKATAEVENT':'KOLKATAEVENT',
        'WINDSPEEDFORECAST':'WINDSPEEDFORECAST',
        'SEAMLESSVIEW':'SEAMLESSVIEW',
        'KOLKATANOWCAST':'KOLKATANOWCAST',
        'SEAMLESSRAINFALL':'SEAMLESSRAINFALL',
        'ABGSITE': 'ABGSITE',
        'RAINFALLACTUALQC':'RAINFALLACTUALQC',
        'KOLKATA2025EVENT':'KOLKATA2025EVENT',
        'JAMMUEVENT':'JAMMUEVENT',
        'DISASTERMONITORING':'DISASTERMONITORING',
        'FOG':'FOG',
        'NHIP':'NHIP'
    },
    PANE_LIST: [
        {
            name: 'elev',
            zindex: '10'
        },
        {
            name: 'subbasin',
            zindex: '150'
        },
        {
            name: 'base',
            zindex: '390'
        },
        {
            name: 'WA',
            zindex: '400'
        },
        {
            name: 'state',
            zindex: '401'
        },
        {
            name: 'district',
            zindex: '402'
        },
        {
            name: 'mandal',
            zindex: '403'
        },
        {
            name: 'block',
            zindex: '403'
        },
        {
            name: 'panchayat',
            zindex: '404'
        },
        {
            name: 'heatMap',
            zindex: '400'
        },
        {
            name: 'village',
            zindex: '410'
        },
        {
            name: 'rivers',
            zindex: '500'
        },
        {
            name: 'marker',
            zindex: '600'
        },
        {
            name: 'popUp',
            zindex: '602'
        },
        {
            name: 'depth',
            zindex: '610'
        },
        {
            name: 'popUpGeoJson',
            zindex: '801'
        },
        {
            name: 'mask',
            zindex: '700'
        },
        {
            name: 'names',
            zindex: '800'
        },
        {
            name: 'imagePoints',
            zindex: '850'
        },
        {
            name: 'max',
            zindex: '900'
        },
        {
            name: 'hazardPoints',
            zindex: '950'
        },
        {
            name: 'labels',
            zindex: '1100'
        },
        {
            name: 'pixiPopup',
            zindex: '1150'
        },
        {
            name: 'measuretool',
            zindex: '1200'
        }
    ],
    DASHBOARD_WISE_COMMON_LAYERS_KEY_MAPPING: {
        'cropAnalytics': 'INDIA',
        'satelliteDataProcessing': 'INDIA',
        'cropGrowth': 'INDIA',
        'contentManagement': 'CONTENTMANAGEMENT',
        'boundaryManagement': 'BOUNDARYMANAGEMENT',
        'pictorialAnalysis': 'PICTORIALANALYSIS',
        'cropGrowthAnalysis': 'INDIA',
        'droughtGis' :'INDIA',
        'analytics': 'CONTENTMANAGEMENT',
        'geoportal': 'INDIA',
        'cropSownAnalysis': 'CONTENTMANAGEMENT',
        'harvestAssessment':'CONTENTMANAGEMENT',
	    'plotAddition' : 'INDIA',
        'cropSownInfo' : 'INDIA',
        'unifiedFarmerDatabase' : 'INDIA',
        'cropSownInformation' : 'INDIA',
        'weatherForecast' : 'INDIA',
        'rainfallForecast' : 'INDIA',
        'rainfallActual' : 'INDIA',
        'soilInformation':'CONTENTMANAGEMENT',
        'temperatureActual' : 'INDIA',
        'temperatureForecast' : 'INDIA',
        'groundTruth': 'INDIA',
        'userAnalyticsFarmer' : 'INDIA',
        'humidityForecast' : 'INDIA',
        'humidityActual' : 'INDIA',
        'windspeedForecast' : 'INDIA',
        'soilMoisture' : 'INDIA',
        'pestStressGis': 'INDIA',
        "ministerDashboard" : 'INDIA',
        'cropStressGis' : 'INDIA',
        'smBasedIrrigationGis': 'INDIA',
        'cropLossAssessment':'INDIA',
        'heatwave':'INDIA',
        'heatindex':'INDIA',
        'thunderstorm':'INDIA',
        'coldwave':'INDIA',
        'nowcast':'INDIA',
        'stationwarnings':'INDIA',
        'kolkataEvent':'INDIA',
        'rainfall-forecast':'INDIA',
        'temperature-forecast':'INDIA',
        'wind-speed-forecast':'INDIA',
        'humidity-forecast':'INDIA',
        'rainfall-actual':'INDIA',
        'seamlessview':'INDIA',
        'kolkata-nowcast':'INDIA',
        'seamless-rainfall':'INDIA',
        'abg-site':'INDIA',
        'rainfall-actual-qc':'INDIA',
        'kolkata2025':'INDIA',
        'jammuEvent':'INDIA',
        'monitor':'INDIA',
        'fog':'INDIA',
        'nhip':'INDIA'
    },
    GROUP_ORDER: [
        'Administrative Boundaries',
        'Revenue Boundaries',
        'Political Boundaries',
        'Hydrology',
        'Irrigation',
        'Thematic Layers',
        'Raster',
        'Surface Water Bodies',
        'Hydromet Spatial Data',
        'Affected Area',
        'Mask Layer',
        'Labels'
    ],
    GROUP_ORDER_CROP: [
        'Administrative Boundaries',
        'Revenue Boundaries',
        'Political Boundaries',
        'Dominant Crops',
        'Crop Sown Raster',
        'Harvest',
        'Polygons',
        'Nutrient Status',
        'Labels'
    ],
    GROUP_ORDER_AGRI_ADMINISTRATIVE: [
        "District Boundary",
        "Ada Boundary",
        "Krishibhavan Boundary",
        "Ward Boundary",
        "Cadastral"
    ],
    GROUP_ORDER_REVENUE_ADMINISTRATIVE: [
        "District Boundary",
        "Taluk Boundary",
        "Village Boundary",
        "Cadastral"
    ],
    GROUP_ORDER_POLITICAL_ADMINISTRATIVE: [
        "Lsc Boundary",
        "Lac Boundary",
        "Cadastral"
    ],
    LABEL_EXCEPTION: {
        'Soil' : true,
        'Streams' : true,
        'Geology' : true,
        'Geomorphology' : true,
        'LULC' : true,
        'Soil Type' : true,
        'Elevation' : true,
        'Soil Erosion' : true,
        'Dominant Crop' : true,
        'MI Tanks' : true,
        'Slope' : true,
        'District Boundaries DominantCrop' : true,
        'Harvest Area Vs Sown Area' : true,
        'State Boundaries' : true,
        'Mask Layer' : true,
        'Agroclimatic zones' : true,
        'Agroeconomic Units' : true,
        'Pineapple' : true,
        'Tea' : true,
        'Sugarcane' : true,
        'Rubber' : true,
        'Coconut' : true,
        'Crop Sown Raster' : true,
        'Harvest Raster' : true,
        'Crop Layer' : true,
        'Farm Polygons' : true,
        'Plot Polygons' : true,
        'Nutrient Status' : true,
        'Final Farm Boundary' : true,
        'Affected LULC' : true,
        'Survey Boundary' : true,
        'Landslide' : true
    },

    LOCTYPE_LAYERNAME : {
        "STATE" : "HEATWAVE:ALL_INDIA_STATE_UPDATED",
        "DISTRICT" : "HEATWAVE:ALL_INDIA_DISTRICT_UPDATED",
        "BLOCK" : "HEATWAVE:ALL_INDIA_BLOCKS_UPDATED",
        "PANCHAYAT" : "KeralaKrishiStack:kerala_panchayat",
        "VILLAGE" : "KeralaKrishiStack:agri_all_india_villages",
        "TALUK" : "KeralaKrishiStack:kerala_taluk"
    },
    LOCTYPE_LAYERNAME_REVENUE: {
        "STATE" : "KeralaKrishiStack:kerala_state",
        "DISTRICT" : "KeralaKrishiStack:kerala_district",
        "BLOCK" : "krishidss:agri_all_india_blocks",
        "PANCHAYAT" : "krishidss:kerala_panchayat",
        "VILLAGE" : "KeralaKrishiStack:agri_all_india_villages",
        "TALUK" : "KeralaKrishiStack:kerala_taluk",
        "LSC" : "KeralaKrishiStack:kerala_lsc_boundary",
        "LAC" : "KeralaKrishiStack:kerala_lac_boundary",
        "ADA":"KeralaKrishiStack:kerala_ada",
        "KRISHIBHAVAN": "KeralaKrishiStack:kerala_krishibhavan",
        "CITY" : "HEATWAVE:ALL_INDIA_MAJOR_CITIES",
    },
    LOCTYPE_CQLFILTERVALUE : {
        "STATE" : "uuid",
        "DISTRICT" : "uuid",
        "BLOCK" : "uuid",
        "PANCHAYAT" : "uuid",
        "VILLAGE" : "village_uuid",
        "ADA" : "ada_uuid",
        "KRISHIBHAVAN" : "kb_uuid",
        "WARD" : "ward_uuid",
        "TALUK" : "taluk_uuid",
        "LSC" : "lsc_uuid",
        "LAC" : "lac_uuid",
        "CITY" : "uuid_city"
    }
}

export const COMPONENT_ROUTE_MAPPING = {
    [AgricultureMapConstants.COMPONENT.FIELDBOUNDARY]: 'fieldBoundary',
    [AgricultureMapConstants.COMPONENT.CROPANALYTICS]: 'cropAnalytics',
    [AgricultureMapConstants.COMPONENT.FIELDHEALTH]: 'fieldHealth',
    [AgricultureMapConstants.COMPONENT.SATELLITEDATAPROCESSING]: 'satelliteDataProcessing',
    [AgricultureMapConstants.COMPONENT.CROPGROWTH]: 'cropGrowth',
    [AgricultureMapConstants.COMPONENT.BOUNDARYMANAGEMENT]: 'boundaryManagement',
    [AgricultureMapConstants.COMPONENT.PICTORIALANALYSIS]: 'pictorialAnalysis',
    [AgricultureMapConstants.COMPONENT.CROPGROWTHANALYSIS]: 'cropGrowthAnalysis',
    [AgricultureMapConstants.COMPONENT.ANALYTICS]: 'analytics',
    [AgricultureMapConstants.COMPONENT.GEOPORTAL] : 'geoportal',
    [AgricultureMapConstants.COMPONENT.CROPSOWNANALYSIS] : 'cropSownAnalysis',
    [AgricultureMapConstants.COMPONENT.HARVESTASSESSMENT] : 'harvestAssessment',
    [AgricultureMapConstants.COMPONENT.PLOTADDITION]: 'plotAddition',
    [AgricultureMapConstants.COMPONENT.CROPSOWNINFO] : 'cropSownInfo',
    [AgricultureMapConstants.COMPONENT.UNIFIEDFARMERDATABASE] : 'unifiedFarmerDatabase',
    [AgricultureMapConstants.COMPONENT.WEATHERFORECAST] : 'weatherforecast',
    [AgricultureMapConstants.COMPONENT.CROPSOWNINFORMATION] : 'cropSownInformation',
    [AgricultureMapConstants.COMPONENT.RAINFALLFORECAST] : 'rainfallForecast',
    [AgricultureMapConstants.COMPONENT.SOILINFORMATION] : 'soilInformation',
    [AgricultureMapConstants.COMPONENT.RAINFALLACTUAL] : 'rainfallActual',
    [AgricultureMapConstants.COMPONENT.TEMPERATUREACTUAL] : 'temperatureActual',
    [AgricultureMapConstants.COMPONENT.GROUNDTRUTH] : 'groundTruth',
    [AgricultureMapConstants.COMPONENT.USERANALYTICSFARMER] : 'userAnalyticsFarmer',
    // [AgricultureMapConstants.COMPONENT.HUMIDITYFORECAST] : 'humidityForecast',
    [AgricultureMapConstants.COMPONENT.HUMIDITYACTUAL] : 'humidityActual',
    // [AgricultureMapConstants.COMPONENT.WINDSPEEDFORECAST] : 'windspeedForecast',
    [AgricultureMapConstants.COMPONENT.SOILTESTING] : 'soilTesting',
    [AgricultureMapConstants.COMPONENT.SOILMOISTURE] : 'soilMoisture',
    [AgricultureMapConstants.COMPONENT.PESTSTRESSGIS] : 'pestStressGis',
    [AgricultureMapConstants.COMPONENT.MINISTERDASHBOARD] : 'ministerDashboard',
    [AgricultureMapConstants.COMPONENT.DROUGHT] : 'drought',
    [AgricultureMapConstants.COMPONENT.CROPSTRESSGIS] : 'cropStressGis',
    [AgricultureMapConstants.COMPONENT.SMBASEDIRRIGATIONGIS] : 'smBasedIrrigationGis',
    [AgricultureMapConstants.COMPONENT.CROPLOSSASSESSMENT] : 'cropLossAssessment',
    [AgricultureMapConstants.COMPONENT.ADD_FARM_PLOT] : 'add-farm-plot',
    [AgricultureMapConstants.COMPONENT.HEATWAVE] : 'heatwave',
    [AgricultureMapConstants.COMPONENT.HEATINDEX] : 'heatindex',
    [AgricultureMapConstants.COMPONENT.THUNDERSTORM] : 'thunderstorm',
    [AgricultureMapConstants.COMPONENT.COLDWAVE] : 'coldwave',
    [AgricultureMapConstants.COMPONENT.NOWCAST] : 'nowcast',
    [AgricultureMapConstants.COMPONENT.STATIONWARNINGS] : 'stationwarnings',
    [AgricultureMapConstants.COMPONENT.KOLKATAEVENT] : 'kolkataEvent',
    [AgricultureMapConstants.COMPONENT.RAINFALLFORECAST] : 'rainfall-forecast',
    [AgricultureMapConstants.COMPONENT.TEMPERATUREFORECAST] : 'temperature-forecast',
    [AgricultureMapConstants.COMPONENT.WINDSPEEDFORECAST] : 'wind-speed-forecast',
    [AgricultureMapConstants.COMPONENT.HUMIDITYFORECAST] : 'humidity-forecast',
    [AgricultureMapConstants.COMPONENT.RAINFALLACTUAL] : 'rainfall-actual',
    [AgricultureMapConstants.COMPONENT.SEAMLESSVIEW] : 'seamlessview',
    [AgricultureMapConstants.COMPONENT.KOLKATANOWCAST] : 'kolkata-nowcast',
    [AgricultureMapConstants.COMPONENT.SEAMLESSRAINFALL] : 'seamless-rainfall',
    [AgricultureMapConstants.COMPONENT.ABGSITE] : 'abg-site',
    [AgricultureMapConstants.COMPONENT.RAINFALLACTUALQC] : 'rainfall-actual-qc',
    [AgricultureMapConstants.COMPONENT.KOLKATA2025EVENT] : 'kolkata2025',
    [AgricultureMapConstants.COMPONENT.JAMMUEVENT]:'jammuEvent',
    [AgricultureMapConstants.COMPONENT.DISASTERMONITORING]:'monitor',
    [AgricultureMapConstants.COMPONENT.FOG]:'fog',
    [AgricultureMapConstants.COMPONENT.NHIP]:'nhip'
};

export const LAYER_TYPES = {
    'TILE_LAYER': 'TILELAYER',
    'WMS_LAYER': 'WMS',
    'VECTOR_LAYER': 'VECTOR',
    'GEOJSON_LAYER': 'GEOJSON',
    'HEATMAP_LAYER': 'HEATMAP',
    'PIXI_LAYER': 'PIXI'
};

export const LOCATIONS_ZOOM_RANGE = {
    [AgricultureMapConstants.LOCATIONS.STATE]: {
        MIN: 6,
        MAX: 18
    },
    [AgricultureMapConstants.LOCATIONS.DISTRICT]: {
        MIN: 6,
        MAX: 12
    },
    [AgricultureMapConstants.LOCATIONS.MANDAL]: {
        MIN: 10,
        MAX: 18
    },
    [AgricultureMapConstants.LOCATIONS.BLOCK]: {
        MIN: 10,
        MAX: 22
    },
    [AgricultureMapConstants.LOCATIONS.PANCHAYAT]: {
        MIN: 12,
        MAX: 22
    },
    [AgricultureMapConstants.LOCATIONS.VILLAGE]: {
        MIN: 14,
        MAX: 18
    },
    [AgricultureMapConstants.LOCATIONS.KRISHIBHAVAN]: {
        MIN: 10,
        MAX: 18
    },
    [AgricultureMapConstants.LOCATIONS.ADA]: {
        MIN: 8,
        MAX: 22
    },
    [AgricultureMapConstants.LOCATIONS.FARM]: {
        MIN: 16,
        MAX: 22
    },
    [AgricultureMapConstants.LOCATIONS.CROP]: {
        MIN: 11,
        MAX: 22
    },
    [AgricultureMapConstants.LOCATIONS.USER_DEFINED]: {
        MIN: 6,
        MAX: 22
    }
};

export const LOCATION_UUID = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        UUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759'
    },
    [AgricultureMapConstants.LOCATIONS.TAMILNADU]: {
        [AgricultureMapConstants.VIEWS.ADMIN]: {
            UUID: 'e98cd5b7-6556-4c0f-a778-3429e1c14a6b'
        },
        [AgricultureMapConstants.VIEWS.BASIN]: {
            UUID: 'e98cd5b7-6556-4c0f-a778-3429e1c14a6b'
        }
    },
    [AgricultureMapConstants.LOCATIONS.ODISHA]: {
        [AgricultureMapConstants.VIEWS.ADMIN]: {
            UUID: 'd19a5290-2e40-494a-83d2-98f4c845b1f1'
        },
        [AgricultureMapConstants.VIEWS.BASIN]: {
            UUID: 'd19a5290-2e40-494a-83d2-98f4c845b1f1'
        }
    },
};

export const LOCATIONS_LATLNG = {
    // [AgricultureMapConstants.LOCATIONS.INDIA]: [17.8, 79.06],
    [AgricultureMapConstants.LOCATIONS.INDIA]: [20.5937, 78.9629],
    [AgricultureMapConstants.LOCATIONS.TAMILNADU]: [10.6574, 78.3380],
    [AgricultureMapConstants.LOCATIONS.ODISHA]: [20.51123117250, 84.43029985120],
    [AgricultureMapConstants.LOCATIONS.KARUNGADU]: [8.686932692770000, 77.652122196000000],
    [AgricultureMapConstants.LOCATIONS.INDIA_NEW]: [22.5937, 78.9629]
};

export const LOCATIONS_ZOOM = {
    // [AgricultureMapConstants.LOCATIONS.INDIA]: 5.25,
    [AgricultureMapConstants.LOCATIONS.INDIA]: 4,
    [AgricultureMapConstants.LOCATIONS.TAMILNADU]: 7,
    [AgricultureMapConstants.LOCATIONS.ODISHA]: 7,
    [AgricultureMapConstants.LOCATIONS.KARUNGADU]: 12
};

export const MAP_OPTIONS: any = {
    minZoom: 5,
    maxZoom: 20,
    zoomSnap: 0.25,
    zoom: LOCATIONS_ZOOM[AgricultureMapConstants.LOCATIONS.KARUNGADU],
    center: LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.KARUNGADU],
    zoomControl: false,
    zoomAnimation: true,
    attributionControl: false
};
export const MAP_OPTIONS_FARMERHELPDESK: any = {
    minZoom: 12,
    maxZoom: 20,
    // zoomSnap: 0.25,
    zoom: LOCATIONS_ZOOM[AgricultureMapConstants.LOCATIONS.KARUNGADU],
    center: LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.KARUNGADU],
    zoomControl: false,
    zoomAnimation: true,
    attributionControl: false
};

export const BASE_LAYER_LIST = {
    [LAYER_TYPES.TILE_LAYER]: [
        // {
        //     name: 'Bhuvan',
        //     displayName: 'Bhuvan',
        //     layerServiceType: 'TILELAYER',
        //     type: 'Base',
        //     view: 'Admin',
        //     url: 'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
        //     attribution: "<a href='http://nrsc.gov.in/'>NRSC</a>Map data © All rights reserved. Powered by <img src='assets/img/footer-logo.png'>",
        //     imagesrc: './assets/imgs/maps/open-street.jpg',
        //     visible: false,
        //     default_select: false,
        //     transparent: false,
        //     crossOrigin:'anonymous'
        // }, 
        {
            name: 'Google Satellite',
            displayName: 'Google Satellite',
            layerServiceType: 'TILELAYER',
            type: 'Base',
            view: 'Admin',
            default_select: false,
            imagesrc: './assets/imgs/satellite.jpg',
            visible: false,
            url: 'https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}',
            maxZoom: MAP_OPTIONS.maxZoom,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            crossOrigin:'anonymous'
        },
        // {
        //     name: 'Bing',
        //     displayName: 'Bing',
        //     layerServiceType: 'Base',
        //     type: 'Base',
        //     admin: 'Admin',
        //     imagesrc: './assets/imgs/maps/bing.png',
        //     visible: false,
        //     maxZoom: 22,
        //     class: 'card card-maps h-100 active',
        //     token: 'As6ObZ20ZW5SjiHkuUN8nm6WggsdAsLtI6C7IzOVG6TJrJNZLxvfsEtMxbKdSjIT', // This is a basic token generated from microsoft basemaps to get add bing base layer (TOKEN ACCOUNT REGISTERED: Vivesh Naren)
        //     subdomains: ['t0', 't1', 't2', 't3'],
        //     maxNativeZoom: 22,
        //     crossOrigin:'anonymous'
        // },

        // {
        //     name: 'Open Street',
        //     displayName: 'Open Street',
        //     layerServiceType: 'TILELAYER',
        //     type: 'Base',
        //     view: 'Admin',
        //     default_select: false,
        //     imagesrc: './assets/imgs/maps/open-street.jpg',
        //     visible: false,
        //     url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
        //     maxZoom: MAP_OPTIONS.maxZoom,
        //     subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        //     class: 'card card-maps h-100',
        //     crossOrigin:'anonymous'
        // },
        {
            "name": "Open Street",
            "displayName": 'Open Street',
            "url": "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
            imagesrc: "/assets/imgs/open-street.jpg",
            "visible": true,
            crossOrigin: 'anonymous',
            "options": {
              "maxZoom": 16,
              "visible": true,
              "opacity": 1,
              "attribution": "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors",
              "base" : true
            }
          },
        {
            name: 'Dark Gray Canvas',
            displayName: 'Dark Gray Canvas',
            layerServiceType: 'TILELAYER',
            type: 'Base',
            view: 'Admin',
            default_select: false,
            imagesrc: './assets/imgs/darkgray.jpg',
            visible: false,
            url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png?key=cb1_25jk_1_c5b3d01c7bd5fcd83938c9ae',
            maxZoom: MAP_OPTIONS.maxZoom,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            class: 'card card-maps h-100',
            crossOrigin:'anonymous'
        },
        {
            name: 'Carto',
            displayName: 'Carto',
            layerServiceType: 'TILELAYER',
            type: 'Base',
            view: 'Admin',
            default_select: false,
            visible: false,
            url: 'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png?key=cb1_25jk_1_c5b3d01c7bd5fcd83938c9ae',
            imagesrc: './assets/imgs/base-map.jpg',
            maxZoom: MAP_OPTIONS.maxZoom,
            crossOrigin:'anonymous'
        },
          {
            name: 'Google Terrain',
            displayName: 'Google Terrain',
            layerServiceType: 'TILELAYER',
            type: 'Base',
            view: 'Admin',
            default_select: false,
            imagesrc: '/assets/imgs/google_terrain.png',
            visible: false,
            "url": "http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
            maxZoom: MAP_OPTIONS.maxZoom,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            crossOrigin: 'anonymous'
        },
        
    ],
};

export const COMMON_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        // 'District Boundaries': {
        //     source: 'INDIA',
        //     displayName: 'District',
        //     name: 'District',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'KeralaKrishiStack:kerala_agri_view_district',
        //     layer_name: 'District Boundaries',
        //     layeroptions_pane: 'block',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
        //     group: 'Administrative Boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
        //     type: LAYER_TYPES.GEOJSON_LAYER,
        //     cql_filter_value: 'district_uuid',
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     onEachFeature: 'handleAdminPolygons',
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     layeroptions_protocol: 'WFS'
        // },
        'State Boundaries': {
            source: 'INDIA',
            displayName: 'State Boundaries',
            name: 'State Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
            layer_name: 'State Boundaries',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundaries': {
            source: 'INDIA',
            displayName: 'District Boundaries',
            name: 'District Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundaries',
            layeroptions_pane: 'max',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        // 'Country Boundary': {
        //     source: 'INDIA',
        //     displayName: 'Country',
        //     name: 'Country Boundary',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
        //     layer_name: 'Country Boundary',
        //     layeroptions_pane: 'depth',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.WMS_LAYER,
        //     type: LAYER_TYPES.WMS_LAYER,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
        //     crs: 'EPSG4326',
        // },
        'State Boundary': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN -1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
            crs: 'EPSG4326',
        },
        'District Boundary Labels': {
            source: 'INDIA',
            displayName: 'District Boundary Labels',
            name: 'District Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN -2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'State_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
        },
        'Block Boundary Labels': {
            source: 'INDIA',
            displayName: 'Block Boundary Labels',
            name: 'Block Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
            layer_name: 'Block Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN -2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'Dist_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
        },
        // 'District Boundary': {
        //     source: 'INDIA',
        //     displayName: 'District',
        //     name: 'District Boundary',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
        //     layer_name: 'District Boundary',
        //     layeroptions_pane: 'state',
        //     // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN -2,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.VECTOR_LAYER,
        //     type: LAYER_TYPES.VECTOR_LAYER,
        //     cql_filter_value: 'state_uuid',
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
        //     crs: 'EPSG4326',
        //     hasLables : true,
        //     applycql_filter: true,
        //     layeroptions_protocol: 'WFS',
        // },
        // 'Block Boundary': {
        //     source: 'INDIA',
        //     displayName: 'Block',
        //     name: 'Block Boundary',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'KeralaKrishiStack:agri_all_india_blocks',
        //     layer_name: 'Block Boundary',
        //     layeroptions_pane: 'district',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.WMS_LAYER,
        //     type: LAYER_TYPES.WMS_LAYER,
        //     cql_filter_value: 'district_uuid',
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     layeroptions_styles: 'KeralaKrishiStack:krishidss_admin_boundary',
        //     crs: 'EPSG4326',
        // },
          'world_view': {
            source: 'INDIA',
            displayName: 'Mask Layer',
            name: 'Mask Layer',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:world_view',
            layer_name: 'Mask Layer',
            layeroptions_pane: 'mask',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN -2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX +4,
            group: 'Mask Layer',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            cql_filter_value: null,
            applycql_filter:true,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:world_view_white,HEATWAVE:inverse_mask',
            crs: 'EPSG4326',
          },
    },
    [AgricultureMapConstants.LOCATIONS.SATELLITE]: {

    },
    [AgricultureMapConstants.LOCATIONS.CONTENTMANAGEMENT]: {

    },
    [AgricultureMapConstants.LOCATIONS.BOUNDARYMANAGEMENT]: {

    },
    [AgricultureMapConstants.LOCATIONS.PICTORIALANALYSIS]: {

    }
}

export const COMMON_LAYER_VIEW_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        [AgricultureMapConstants.VIEWS.AGRI]: {
            'State Boundaries': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_state',
                layer_name: 'State Boundaries',
                layeroptions_pane: 'village',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                // group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'District Boundaries': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_agri_view_district',
                layer_name: 'District Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'district_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'Block Boundaries': {
                source: 'INDIA',
                displayName: 'Block',
                name: 'Block Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:agri_all_india_blocks',
                layer_name: 'Block Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'block_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'Ada Boundaries': {
                source: 'INDIA',
                displayName: 'ADA',
                name: 'ADA',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_ada',
                layer_name: 'ADA',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'district_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'Panchayat Boundaries': {
                source: 'INDIA',
                displayName: 'Panchayat',
                name: 'Panchayat Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_panchayat',
                layer_name: 'Panchayat Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'mandal_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'Krishibhavan Boundaries': {
                source: 'INDIA',
                displayName: 'Krishi Bhavan',
                name: 'Krishi Bhavan',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_krishibhavan',
                layer_name: 'Krishi Bhavan',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'ada_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_krishibhavan_boundary',
                crs: 'EPSG4326',
                applycql_filter : true,
                layeroptions_protocol: 'WFS',
            },
            'Village Boundaries': {
                source: 'INDIA',
                displayName: 'Village',
                name: 'Village Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:agri_all_india_villages',
                layer_name: 'Village Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'village_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'District Boundary': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District Boundary',
                visible: true,
                hasLegend: true,
                legendName: 'ADMINISTRATIVE_BOUNDARY',
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_district',
                layer_name: 'District Boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'state_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_districts_boundary',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            'Block Boundary': {
                source: 'INDIA',
                displayName: 'Block',
                name: 'Block Boundary',
                visible: true,
                hasLegend: true,
                legendName: 'ADMINISTRATIVE_BOUNDARY',
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:agri_all_india_blocks',
                layer_name: 'Block Boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_block_boundary',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            // 'Panchayat Boundary': {
            //     source: 'INDIA',
            //     displayName: 'Panchayat',
            //     name: 'Panchayat Boundary',
            //     visible: true,
            //     hasLegend: true,
            //     legendName: 'ADMINISTRATIVE_BOUNDARY',
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'KeralaKrishiStack:kerala_panchayat',
            //     layer_name: 'Panchayat Boundary',
            //     layeroptions_pane: 'max',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Administrative Boundaries',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     cql_filter_value: 'mandal_uui',
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_styles: 'KeralaKrishiStack:kerala_panchayat_boundary',
            //     crs: 'EPSG4326',
            //     applycql_filter : true
            // },
            'Krishibhavan Boundary': {
                source: 'INDIA',
                displayName: 'Krishi Bhavan',
                name: 'Krishi Bhavan',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_krishibhavan',
                layer_name: 'Krishibhavan Boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'ada_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_krishibhavan_boundary',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'Village Boundary': {
                source: 'INDIA',
                displayName: 'Village',
                name: 'Village Boundary',
                visible: true,
                hasLegend: true,
                legendName: 'ADMINISTRATIVE_BOUNDARY',
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_village',
                layer_name: 'Village Boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'panchayat_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_village_boundary',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'District Boundary Labels': {
                source: 'INDIA',
                displayName: 'District Boundary Labels',
                name: 'District Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_agri_view_district',
                layer_name: 'District Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_agri_view_district_labels',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'Block Boundary Labels': {
                source: 'INDIA',
                displayName: 'Block Boundary Labels',
                name: 'Block Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:agri_all_india_blocks',
                layer_name: 'Block Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:agri_all_india_blocks',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'Ada Boundary Labels': {
                source: 'INDIA',
                displayName: 'ADA Boundary Labels',
                name: 'ADA Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_ada',
                layer_name: 'ADA Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_ada_labels',
                crs: 'EPSG4326',
            },
            'Krishibhavan Boundary Labels': {
                source: 'INDIA',
                displayName: 'Krishibhavan Boundary Labels',
                name: 'Krishibhavan Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_krishibhavan',
                layer_name: 'Krishibhavan Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'ada_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_krishibhavan_labels',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            // 'Panchayat Boundary Labels': {
            //     source: 'INDIA',
            //     displayName: 'Panchayat Boundary Labels',
            //     name: 'Panchayat Boundary Labels',
            //     visible: true,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'KeralaKrishiStack:kerala_panchayat',
            //     layer_name: 'Panchayat Boundary Labels',
            //     layeroptions_pane: 'max',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Labels',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     // cql_filter_value: 'state_uuid',
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_styles: 'KeralaKrishiStack:agri_all_india_panchayat',
            //     crs: 'EPSG4326',
            //     applycql_filter : true
            // },
            'Village Boundary Labels': {
                source: 'INDIA',
                displayName: 'Village Boundary Labels',
                name: 'Village Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:agri_all_india_villages',
                layer_name: 'Village Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:agri_all_india_villages',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'District Boundaries Labels': {
                source: 'INDIA',
                displayName: 'District Boundaries Labels',
                name: 'District Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_agri_view_district',
                layer_name: 'District Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_agri_view_district_labels',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            // 'Block Boundaries Labels': {
            //     source: 'INDIA',
            //     displayName: 'Block Boundaries Labels',
            //     name: 'Block Boundaries Labels',
            //     visible: true,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'KeralaKrishiStack:agri_all_india_blocks',
            //     layer_name: 'Block Boundaries Labels',
            //     layeroptions_pane: 'district',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Labels',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     cql_filter_value: 'state_uuid',
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_styles: 'KeralaKrishiStack:agri_all_india_blocks',
            //     crs: 'EPSG4326',
            //     applycql_filter : true
            // },
            'Ada Boundaries Labels': {
                source: 'INDIA',
                displayName: 'Ada Boundaries Labels',
                name: 'Ada Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_ada',
                layer_name: 'Ada Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_ada_labels',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            // 'Panchayat Boundaries Labels': {
            //     source: 'INDIA',
            //     displayName: 'Panchayat Boundaries Labels',
            //     name: 'Panchayat Boundaries Labels',
            //     visible: true,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'KeralaKrishiStack:kerala_panchayat',
            //     layer_name: 'Panchayat Boundaries Labels',
            //     layeroptions_pane: 'state',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Labels',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     // cql_filter_value: 'state_uuid',
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_styles: 'KeralaKrishiStack:agri_all_india_panchayat',
            //     crs: 'EPSG4326',
            //     applycql_filter : true
            // },
            'Krishibhavan Boundaries Labels': {
                source: 'INDIA',
                displayName: 'Krishibhavan Boundaries Labels',
                name: 'Krishibhavan Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_krishibhavan',
                layer_name: 'Krishibhavan Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'ada_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_krishibhavan_labels',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'Village Boundaries Labels': {
                source: 'INDIA',
                displayName: 'Village Boundaries Labels',
                name: 'Village Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:agri_all_india_villages',
                layer_name: 'Village Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:agri_all_india_villages',
                crs: 'EPSG4326',
                applycql_filter : true
            },
        },
        [AgricultureMapConstants.VIEWS.REVENUE]: {
            'State Boundaries': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_state',
                layer_name: 'State Boundaries',
                layeroptions_pane: 'village',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                // group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'District Boundary': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District Boundary',
                visible: true,
                hasLegend: true,
                legendName: 'ADMINISTRATIVE_BOUNDARY',
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_district',
                layer_name: 'state',
                layeroptions_pane: 'block',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Revenue Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'state_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_districts_boundary',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            'Taluk Boundary': {
                source: 'INDIA',
                displayName: 'Taluk Boundary',
                name: 'Taluk Boundary',
                visible: true,
                hasLegend: true,
                legendName: 'ADMINISTRATIVE_BOUNDARY',
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_taluk',
                layer_name: 'Taluk Boundary',
                layeroptions_pane: 'district',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Revenue Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'state_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_taluk_boundary',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            'Village Boundary': {
                source: 'INDIA',
                displayName: 'Village Boundary',
                name: 'Village Boundary',
                visible: true,
                hasLegend: true,
                legendName: 'ADMINISTRATIVE_BOUNDARY',
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_village',
                layer_name: 'Village Boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'state_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_village_boundary',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            'District Boundaries': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_district',
                layer_name: 'District Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'Revenue Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'district_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'Taluk Boundaries': {
                source: 'INDIA',
                displayName: 'Taluk',
                name: 'Taluk',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_taluk',
                layer_name: 'Taluk',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'Revenue Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'district_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true,
                // layeroptions_styles: 'KeralaKrishiStack:kerala_taluk_boundary_labels',
                // crs: 'EPSG4326',
            },
            'Village Boundaries': {
                source: 'INDIA',
                displayName: 'Village',
                name: 'Village',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_village',
                layer_name: 'Village',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'Revenue Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'taluk_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'District Boundary Labels': {
                source: 'INDIA',
                displayName: 'District Boundary Labels',
                name: 'District Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_district',
                layer_name: 'District Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_district_labels',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'Taluk Boundary Labels': {
                source: 'INDIA',
                displayName: 'Taluk Boundary Labels',
                name: 'Taluk Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_taluk',
                layer_name: 'Taluk Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'state_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_taluk_boundary_labels',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            'Village Boundary Labels': {
                source: 'INDIA',
                displayName: 'Village Boundary Labels',
                name: 'Village Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_village',
                layer_name: 'Village Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_village',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'District Boundaries Labels': {
                source: 'INDIA',
                displayName: 'District Boundaries Labels',
                name: 'District Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_district',
                layer_name: 'District Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_district_labels',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            'Taluk Boundaries Labels': {
                source: 'INDIA',
                displayName: 'Taluk Boundaries Labels',
                name: 'Taluk Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_taluk',
                layer_name: 'Taluk Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'state_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_taluk_boundary_labels',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            'Village Boundaries Labels': {
                source: 'INDIA',
                displayName: 'Village Boundaries Labels',
                name: 'Village Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_village',
                layer_name: 'Village Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'taluk_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_village_labels',
                crs: 'EPSG4326',
                applycql_filter : true
            },
            // 'Ward Boundary': {
            //     component: AgricultureMapConstants.COMPONENT.GEOPORTAL,
            //     source: AgricultureMapConstants.SOURCES.ALL,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     displayName: 'Ward',
            //     name: 'Ward',
            //     visible: false,
            //     hasLegend: false,
            //     legendName: 'cropField',
            //     layeroptions_show_on_selector: false,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layeroptions_name: 'KeralaKrishiStack:kerala_ward_boundary',
            //     layeroptions_pane: 'state',
            //     layeroptions_min_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            //     layeroptions_max_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Revenue Boundaries',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     layer_name: 'Ward Boundary',
            //     layeroptions_styles: 'KeralaKrishiStack:kerala_ward_boundary',
            //     // onEachFeature: 'handleBasinPolygons',
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     // layeroptions_protocol: 'WFS',
            // },
            // 'Ward Boundary Labels': {
            //     component: AgricultureMapConstants.COMPONENT.GEOPORTAL,
            //     source: AgricultureMapConstants.SOURCES.ALL,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     displayName: 'Ward Boundary Labels',
            //     name: 'Ward Boundary Labels',
            //     visible: false,
            //     hasLegend: true,
            //     legendName: 'cropField',
            //     layeroptions_show_on_selector: false,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layeroptions_name: 'KeralaKrishiStack:kerala_ward_boundary',
            //     layeroptions_pane: 'village',
            //     layeroptions_min_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            //     layeroptions_max_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Labels',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     layer_name: 'Ward Labels',
            //     layeroptions_styles: 'KeralaKrishiStack:kerala_ward_boundary_labels',
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_protocol: 'WFS',
            // },
            // 'Cadastral': {
            //     component: null,
            //     source: AgricultureMapConstants.SOURCES.ALL,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     displayName: 'Cadastral',
            //     name: 'Cadastral',
            //     visible: true,
            //     hasLegend: false,
            //     legendName: '',
            //     layeroptions_show_on_selector: false,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layeroptions_name: 'KeralaKrishiStack:cadastral_data',
            //     layeroptions_pane: 'WA',
            //     layeroptions_min_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MIN,
            //     layeroptions_max_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Revenue Boundaries',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     layer_name: 'Cadastral',
            //     layeroptions_styles : 'cadastral_boundary',
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            // },
            // 'Cadastral Labels': {
            //     source: 'INDIA',
            //     displayName: 'Cadastral Labels',
            //     name: 'Cadastral Labels',
            //     visible: true,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'KeralaKrishiStack:cadastral_data',
            //     layer_name: 'Cadastral Labels',
            //     layeroptions_pane: 'block',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MIN,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Labels',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     cql_filter_value: null,
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_styles: 'KeralaKrishiStack:cadastral_labels',
            //     crs: 'EPSG4326',
            //     applycql_filter : false
            // },
        },
        [AgricultureMapConstants.VIEWS.POLITICAL]: {
            'State Boundaries': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_state',
                layer_name: 'State Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                // group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                applycql_filter : true
            },
            'Lsc Boundary': {
                component: AgricultureMapConstants.COMPONENT.GEOPORTAL,
                source: AgricultureMapConstants.SOURCES.ALL,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                displayName: 'LSC',
                name: 'LSC',
                visible: true,
                hasLegend: true,
                legendName: 'ADMINISTRATIVE_BOUNDARY',
                layeroptions_show_on_selector: false,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layeroptions_name: 'KeralaKrishiStack:kerala_lsc_boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Political Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                layer_name: 'Lsc Boundary',
                layeroptions_styles: 'KeralaKrishiStack:krishidss_lsc_boundary',
                // onEachFeature: 'handleBasinPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_protocol: 'WFS',
            },
            'Lac Boundary': {
                component: AgricultureMapConstants.COMPONENT.GEOPORTAL,
                source: AgricultureMapConstants.SOURCES.ALL,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                displayName: 'LAC',
                name: 'LAC',
                visible: true,
                hasLegend: true,
                legendName: 'ADMINISTRATIVE_BOUNDARY',
                layeroptions_show_on_selector: false,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layeroptions_name: 'KeralaKrishiStack:kerala_lac_boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Political Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                layer_name: 'Lac Boundary',
                layeroptions_styles: 'KeralaKrishiStack:krishidss_lac_boundary',
                // onEachFeature: 'handleBasinPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_protocol: 'WFS',
            },
            'Lsc Boundaries': {
                component: AgricultureMapConstants.COMPONENT.GEOPORTAL,
                source: AgricultureMapConstants.SOURCES.ALL,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                displayName: 'LSC',
                name: 'LSC',
                visible: true,
                // hasLegend: true,
                // legendName: 'ADMINISTRATIVE_BOUNDARY',
                layeroptions_show_on_selector: false,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layeroptions_name: 'KeralaKrishiStack:kerala_lsc_boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Political Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                // cql_filter_value: 'lsc_uuid',
                // cql_filter: null,
                layer_name: 'Lsc Boundaries',
                layeroptions_styles: 'KeralaKrishiStack:krishidss_lsc_boundary',
                // onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                // applycql_filter : true
            },
            'Lac Boundaries': {
                component: AgricultureMapConstants.COMPONENT.GEOPORTAL,
                source: AgricultureMapConstants.SOURCES.ALL,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                displayName: 'LAC',
                name: 'LAC',
                visible: true,
                // hasLegend: true,
                // legendName: 'ADMINISTRATIVE_BOUNDARY',
                layeroptions_show_on_selector: false,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layeroptions_name: 'KeralaKrishiStack:kerala_lac_boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Political Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                // cql_filter_value: 'lac_uuid',
                // cql_filter: null,
                layer_name: 'LAC',
                layeroptions_styles: 'KeralaKrishiStack:krishidss_lac_boundary',
                // onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                // applycql_filter : true
            },
            'Lsc Boundary Labels': {
                source: 'INDIA',
                displayName: 'Lsc Boundary Labels',
                name: 'Lsc Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_lsc_boundary',
                layer_name: 'Lsc Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'state_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_lsc_boundary_labels',
                crs: 'EPSG4326',
                layeroptions_protocol: 'WFS',
                // applycql_filter : true
            },
            
            'Lac Boundary Labels': {
                source: 'INDIA',
                displayName: 'Lac Boundary Labels',
                name: 'Lac Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_lac_boundary',
                layer_name: 'Lac Boundary Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'state_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_lac_boundary_labels',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            'Lsc Boundaries Labels': {
                source: 'INDIA',
                displayName: 'Lsc Boundaries Labels',
                name: 'Lsc Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_lsc_boundary',
                layer_name: 'Lsc Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'lsc_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_lsc_boundary_labels',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            'Lac Boundaries Labels': {
                source: 'INDIA',
                displayName: 'Lac Boundaries Labels',
                name: 'Lac Boundaries Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:kerala_lac_boundary',
                layer_name: 'Lac Boundaries Labels',
                layeroptions_pane: 'labels',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                // cql_filter_value: 'lsc_uuid',
                // cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'KeralaKrishiStack:kerala_lac_boundary_labels',
                crs: 'EPSG4326',
                // applycql_filter : true
            },
            // 'Ward Boundary': {
            //     component: AgricultureMapConstants.COMPONENT.GEOPORTAL,
            //     source: AgricultureMapConstants.SOURCES.ALL,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     displayName: 'Ward',
            //     name: 'Ward',
            //     visible: false,
            //     hasLegend: false,
            //     legendName: 'cropField',
            //     layeroptions_show_on_selector: false,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layeroptions_name: 'KeralaKrishiStack:kerala_ward_boundary',
            //     layeroptions_pane: 'state',
            //     layeroptions_min_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            //     layeroptions_max_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Political Boundaries',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     layer_name: 'Ward Boundary',
            //     layeroptions_styles: 'KeralaKrishiStack:kerala_ward_boundary',
            //     // onEachFeature: 'handleBasinPolygons',
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     // layeroptions_protocol: 'WFS',
            // },
            // 'Ward Boundary Labels': {
            //     component: AgricultureMapConstants.COMPONENT.GEOPORTAL,
            //     source: AgricultureMapConstants.SOURCES.ALL,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     displayName: 'Ward Boundary Labels',
            //     name: 'Ward Boundary Labels',
            //     visible: false,
            //     hasLegend: true,
            //     legendName: 'cropField',
            //     layeroptions_show_on_selector: false,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layeroptions_name: 'KeralaKrishiStack:kerala_ward_boundary',
            //     layeroptions_pane: 'village',
            //     layeroptions_min_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            //     layeroptions_max_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Labels',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     layer_name: 'Ward Labels',
            //     layeroptions_styles: 'KeralaKrishiStack:kerala_ward_boundary_labels',
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_protocol: 'WFS',
            // },
            // 'Cadastral': {
            //     component: null,
            //     source: AgricultureMapConstants.SOURCES.ALL,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     displayName: 'Cadastral',
            //     name: 'Cadastral',
            //     visible: true,
            //     hasLegend: false,
            //     legendName: '',
            //     layeroptions_show_on_selector: false,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layeroptions_name: 'KeralaKrishiStack:cadastral_data',
            //     layeroptions_pane: 'WA',
            //     layeroptions_min_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MIN,
            //     layeroptions_max_zoom:
            //         LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Political Boundaries',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     layer_name: 'Cadastral',
            //     layeroptions_styles : 'cadastral_boundary',
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            // },
            // 'Cadastral Labels': {
            //     source: 'INDIA',
            //     displayName: 'Cadastral Labels',
            //     name: 'Cadastral Labels',
            //     visible: true,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'KeralaKrishiStack:cadastral_data',
            //     layer_name: 'Cadastral Labels',
            //     layeroptions_pane: 'block',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MIN,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.FARM].MAX,
            //     group: 'Labels',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     cql_filter_value: null,
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_styles: 'KeralaKrishiStack:cadastral_labels',
            //     crs: 'EPSG4326',
            //     applycql_filter : false
            // },

        }
    }
}


export const COMMON_LAYERS_LIST: any = {
    MINI_MAP_LAYERS: {
        [AgricultureMapConstants.VIEWS.ADMIN]: {
            'LOCATION_BOUNDARY': {
                source: 'INDIA',
                displayName: 'Location Boundary',
                name: 'Location Boundary',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'KeralaKrishiStack:',
                layer_name: 'State Boundary',
                layeroptions_pane: 'state',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'KRISHI_DSS_GEOSERVER_URL',
                layeroptions_protocol: 'WFS',
                fitToBounds: true,
                onEachFeature: 'handleAdminPolygons'
            }
        }
    }
}
